// -------------- 以下为外部引用，若不用可【本地注释】 ---------------------------------
// ---------------------- 系统 ---------------------------------
import { subRoutes as sysConfigRoutes } from './sysConfig/SysConfigModule';

export const routes = [
  {
    // 外部引用-系统
    path: '/sysConfig',
    subRoutes: sysConfigRoutes
  }
];
